import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.matchName
var driverName = global.driverName
var driverNameT = global.driverNameT
var orderName = global.orderName
var crmServer = global.crmServer
var wmsStockName = global.wmsStockName
var wmsAccessName = global.wmsAccessName
var crmServer3 = global.crmServer3
// crm2与crm3兼容
// 根据登陆userId获取车队长的信息
export let QRcodeCDZInfo = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sCompany/QRcodeCDZInfo`, p)
  } else {
    return post(`${crmServer}registerInfo/QRcodeCDZInfo`, p)
  }
}
// 同步货源客户列表
export const CusterExt2Data = p => post(`${crmServer}scustomer/queryCusterExt2DataByTenantCode`, p)
export const CusterExt2DataCrm3 = p => post(`${crmServer3}/sCustomer/queryCusterExt2DataByTenantCode`, p)
// export let CusterExt2Data = p => {
//   if (localStorage.getItem('isCutCrm3') == 1) {
//     return post(`${crmServer3}/scustomer/queryCusterExt2DataByTenantCode`, p)
//   } else {
//     return post(`${crmServer}scustomer/queryCusterExt2DataByTenantCode`, p)
//   }
// }
// 司机查询
export const cDlist = p => post(name + '/cDriverInfo/list', p)
// 司机添加
export const cDadd = p => post(name + '/cDriverInfo/add', p)
// 司机修改
export const cDupdate = p => post(name + '/cDriverInfo/update', p)
// 司机删除
export const cDdelete = p => post(name + '/cDriverInfo/delete', p)
// 车辆查询
export const cVIlist = p => post(name + '/cVehicleInfo/list', p)
// 车辆添加
export const cVIadd = p => post(name + '/cVehicleInfo/add', p)
// 车辆修改
export const cVIupdate = p => post(name + '/cVehicleInfo/update', p)
// 车辆删除
export const cVIdelete = p => post(name + '/cVehicleInfo/delete', p)
// 车长查询
export const cVLlist = p => post(name + '/cVehicleLong/list', p)
// 车长添加
export const cVLadd = p => post(name + '/cVehicleLong/add', p)
// 车长修改
export const cVLupdate = p => post(name + '/cVehicleLong/update', p)
// 车长删除
export const cVLdelete = p => post(name + '/cVehicleLong/delete', p)
// 车辆类型查询
export const cVTlist = p => post(name + '/cVehicleType/list', p)
// 车辆类型添加
export const cVTadd = p => post(name + '/cVehicleType/add', p)
// 车辆类型修改
export const cVTupdate = p => post(name + '/cVehicleType/update', p)
// 车辆类型删除
export const cVTdelete = p => post(name + '/cVehicleType/delete', p)
// 区域查询
export const vRlist = p => post(name + '/vRegion/list', p)
// 区域添加
export const vRadd = p => post(name + '/vRegion/add', p)
// 区域修改
export const vRupdate = p => post(name + '/vRegion/update', p)
// 区域删除
export const vRdelete = p => post(name + '/vRegion/delete', p)
// 区域页面获取流向
export const flowForRegionList = p => post(name + '/vRegionFlow/flowForRegionList', p)
// 流向查询
export const vRFlist = p => post(name + '/vRegionFlow/list', p)
// 流向添加
export const vRFadd = p => post(name + '/vRegionFlow/add', p)
// 流向修改
export const vRFupdate = p => post(name + '/vRegionFlow/update', p)
// 流向删除
export const vRFdelete = p => post(name + '/vRegionFlow/delete', p)

// 货物查询列表
export const vGList = p => post(name + '/vGoods/list', p)
// 货物删除
export const vGdelete = p => post(name + '/vGoods/delete', p)
// 货物添加流向
export const updateFlow = p => post(name + '/vGoods/updateFlow', p)
// 货物加急
export const updateIsUrgent = p => post(name + '/vGoods/updateIsUrgent', p)
// 手动配货数据排序
export const vGAList = p => post(name + '/vGoods/addlist', p)
// 手动配货数据排序
export const addGoodslist = p => post(name + '/vGoods/addGoodslist', p)
// 手动配货加卷减卷
export const vGaddOrMinusList = p => post(name + '/vGoods/addOrMinusList', p)
// 配货车辆查询
export const getCVehicleInfo = p => post(name + '/base/getCVehicleInfo', p)
// 配货司机查询
export const getCDriverInfo = p => post(name + '/base/getCDriverInfo', p)
// 配货确认
export const saveDistribution = p => post(name + '/vDistribution/saveDistribution', p)// vDistributionDetailList
// 提单列表
export const vBlist = p => post(name + '/vBill/list', p)
// 配货id查询提货单列表
export const vDistributionBillListById = p => post(name + '/vDistributionBillRel/getDistributionBillListById', p)
export const sendMsgInfo = p => post(name + '/vDistributionBillRel/sendMsgInfo', p)

// 提单详情
export const vBdelete = p => post(name + '/vBill/delete', p)
// 区域配货
export const regionGoods = p => post(name + '/vGoods/regionGoods', p)
// 区域配货货物货物
export const regionGoodsInfo = p => post(name + '/vGoods/regionGoodsInfo', p)
// 区域里面的流向
export const vRegionFlow = p => post(name + '/vRegionFlow/list', p)
// 配货单列表
export const vDbList = p => post(name + '/vDistribution/list', p)
// 配货单修改
export const vDbUpdate = p => post(name + '/vDistribution/update', p)
// 配货单撤销
export const vDbDelete = p => post(name + '/vDistribution/delete', p)
// 配货单详情
export const vDistributionDetailList = p => post(name + '/vGoods/vGoodList', p)
// 板材导入
export const impVGoodsPanelExcel = p => post(name + '/vGoods/impVGoodsPanelExcel', p)
// 外库导入
export const impVGoodSexternalExcel = p => post(name + '/vGoods/impVGoodSexternalExcel', p)
// 提单导入
export const impVGoodBillExcel = p => post(name + '/vGoods/impVGoodBillExcel', p)

// 自动配货
export const autoMatchGoods = p => post(name + '/vGoods/autoMatchGoods', p)
// 推送
export const pushDistribution = p => post(name + '/vDistribution/pushDistribution', p)
// 场外推送
export const pushDistributionList = p => post(name + '/vDistribution/pushDistributionList', p)
// 货物类型
export const cProductTypeList = p => post(name + '/base/cProductTypeList', p)
// 竞价货源
export const getVBillOffer = p => post(name + '/vBillOffer/getVBillOffer', p)
// 报价
export const VBOadd = p => post(name + '/vBillOffer/add', p)
// 货源明细
export const vGoodBillList = p => post(name + '/vGoods/vGoodBillList', p)
// 非系统手动配货
export const saveUnDistribution = p => post(name + '/vDistribution/saveUnDistribution', p)
// 非系统手动配货
export const receiveBill = p => post(name + '/vBill/receiveBill', p)
// 获取司机列表
export const getCDriverInfoList = p => post(name + '/base/getCDriverInfoList', p)
// 获取客户列表
export const getCustomerList = p => post(name + '/rule/getCustomerList', p)
// 获取规则列表
export const ruleList = p => post(name + '/rule/list', p)
// 新增规则
export const ruleAdd = p => post(name + '/rule/add', p)
export const getWhCargo = p => post(name + '/rule/getWhCargo', p)
// 修改规则
export const ruleUpdate = p => post(name + '/rule/update', p)
// 删除规则
export const ruleDelete = p => post(name + '/rule/delete', p)
// 配货跳转
export const ruleDetail = p => post(name + '/rule/detail', p)

// 获取计划列表
export const listPage = p => post(name + '/rulePlan/listPage', p)
export const listPageStorage = p => post(name + '/rulePlanApi/listPage', p)// 仓储-调用
// 添加计划
export const rulePlanAdd = p => post(name + '/rulePlan/add', p)
// 删除计划
export const rulePlanDel = p => post(name + '/rulePlan/delete', p)
// 修改状态下发撤回
export const updateStatus = p => post(name + '/rulePlan/updateStatus', p)
// 编辑计划
export const rulePlanUpdate = p => post(name + '/rulePlan/update', p)
// 撤销记录列表
export const vDistributionCancel = p => post(name + '/vDistributionCancel/list', p)
// 撤销详情
export const vDistributionCancelGoodRel = p => post(name + '/vDistributionCancelGoodRel/list', p)

// 撤回
export const cancelDistribution = p => post(name + '/vDistribution/cancelDistribution ', p)

// 排号司机列表
export const getCDriverInfoListPage = p => post(name + '/base/getCDriverInfoListPage', p)

// 司机统计
export const driverAndVehicleCount = p => post(driverNameT + '/cDriverVehicleRel/driverAndVehicleCount', p)
// 配货统计
export const distributionNumCount = p => post(name + '/vDistribution/distributionNumCount', p)
// 撤单统计
export const cancelCountt = p => post(name + '/vDistributionCancel/cancelCount', p)
// 实时配货
export const actualDistributionList = p => post(name + '/vDistribution/actualDistributionList', p)
// 配货趋势
export const trendStatistics = p => post(name + '/vDistribution/trendStatisticsOfDistribution', p)
// 编辑提单四要素
export const VBupdateVBill = p => post(name + '/vBill/updateVBill', p)
// 线下配货
export const updateChannelType = p => post(name + '/vDistribution/updateChannelType', p)
// 订单列表
export const orderList = p => post(`/${orderName}/sOrder/list`, p)
// 报价单列表
export const sOrderOfferList = p => post(`/${orderName}/sOrderOffer/list`, p)
// 报价
export const sOrderOfferAdd = p => post(`/${orderName}/sOrderOffer/add`, p)
// 报价单删除
export const sOrderOfferDel = p => post(`/${orderName}/sOrderOffer/delete`, p)
// 订单分派
export const wayAssignment = p => post(`/${orderName}/way/assignment`, p)
// 指派货源接收
export const receiveOrder = p => post(`/${orderName}/sOrderOffer/receiveOrder`, p)
// 获取客户列表
export const getRelationCustomer = p => post(`${name}/base/getRelationCustomer`, p)
// 获取货源
export const accessVgoods = p => post(`${name}/vGoods/accessVgoods`, p)
// 司机报号列表
export const choiceDriverSigninList = p => post(driverName + '/cDriverInfo/choiceDriverSigninList', p)
// 获取基本信息
export const findDictByType = p => post(`/${orderName}/sDict/findDictByType`, p)
// 火运计划列表
export const TRPlist = p => post(`${name}/trainTransportPlan/list`, p)
// 同步货源查看库存
export const wmsStockGoods = p => post(`${name}/vGoods/wmsStockGoods`, p)
// 全部同步
export const synAllWmsGoods = p => post(`${name}/vGoods/synAllWmsGoods`, p)
// 部分同步
export const synWmsGoods = p => post(`${name}/vGoods/synWmsGoods`, p)
// 螺纹钢货物类型
export const getDictionary = p => post(`${wmsStockName}/b/dictionary/getDictionary`, p)
// 螺纹钢获取客户
export const LWGgetRelationCustomer = p => post(`${wmsStockName}/instock/getRelationCustomer`, p)
// 螺纹钢车船号
export const getLwgStockVehicleNumber = p => post(`${wmsAccessName}/whOutstockPlan/getLwgStockVehicleNumberHz`, p)
// 螺纹钢品牌-产地
export const selectScrewThreadSteelAttribute = p => post(`${wmsAccessName}/inStockInstruction/selectScrewThreadSteelAttribute`, p)
// 螺纹钢库存件数
export const getLwgStockCargoCount = p => post(`${wmsAccessName}/whOutstockPlan/getLwgStockCargoCountHz`, p)
// 螺纹钢列表
export const CDElist = p => post(`${name}/vDistributionEmptyBundle/list`, p)
// 螺纹钢详情列表
export const CDdetail = p => post(`${name}/vDistributionEmptyBundle/detail`, p)
// 螺纹钢删除
export const CDdelete = p => post(`${name}/vDistributionEmptyBundle/delete`, p)
// 螺纹钢配货单保存
export const addMatchGoods = p => post(`${name}/vDistributionEmptyBundle/addMatchGoods`, p)
// 螺纹钢配货货物详情
export const goodsList = p => post(`${name}/vDistributionEmptyBundle/goodsList`, p)
// 实配货 上传平台获取货物类型和地址
export const getGoodTypeByDisId = p => post(`${name}/vGoods/getGoodTypeByDisId`, p)
// 虚配货 上传平台获取货物类型
export const getGoodTypeByDisBundelId = p => post(`${name}/vGoods/getGoodTypeByDisBundelId`, p)
// 配货单上传网络货运平台
export const uploadPlatform = p => post(`${name}/vDistribution/uploadPlatform`, p)
// 配货单取消网络货运平台
export const cancelUpload = p => post(name + '/vDistribution/cancelUpload', p)
// 配货端编辑备注
export const updateRemark = p => post(name + '/vDistribution/updateRemark', p)
// 流向卸点列表
export const vFlowUnloadList = p => post(name + '/vFlowUnload/list', p)
// 流向卸点添加
export const vFlowUnloadAdd = p => post(name + '/vFlowUnload/add', p)
// 流向卸点修改
export const vFlowUnloadUpdate = p => post(name + '/vFlowUnload/update', p)
// 流向卸点删除
export const vFlowUnloadDelete = p => post(name + '/vFlowUnload/delete', p)
// 判断配货单是否可以上报distributionType //配货单类型1.实捆 2.虚
export const isUploadPlatform = p => post(name + '/vDistribution/isUploadPlatform', p)
// 码单导入
export const impBillGoodsExcel = p => post(name + '/vGoods/impBillGoodsExcel', p)
// 码单删除
export const deleteM = p => post(name + '/vBill/deleteM', p)
// 码单货物删除
export const deleteMGoods = p => post(name + '/vGoods/deleteGoods', p)
// 成品运单上报获取货物类型
export const getCpGoodTypeByDisId = p => post(name + '/vGoods/getCpGoodTypeByDisId', p)
// 判断成品运单 是否可以上传网络货运平台
export const isUploadCp = p => post(name + '/vDistribution/isUploadCp', p)
// 成品运单上报网络货运平台
export const uploadCp = p => post(name + '/vDistribution/uploadCp', p)
// 金泰原料运单
export const vDistributionListForTJ = p => post(name + '/vDistribution/vDistributionListForTJ', p)
// 金泰原料运单添加货物
export const addGoodForVDistribution = p => post(name + '/vGoods/addGoodForVDistribution', p)
// 金泰原料运单查询货物
export const vgoodsByNo = p => post(name + '/vGoods/vgoodsByNo', p)
// 金泰原料运单下的货物列表
export const vGoodListForJT = p => post(name + '/vGoods/vGoodListForJT', p)
// 金泰原料运单下的货物修改
export const updateGoodForVDistribution = p => post(name + '/vGoods/updateGoodForVDistribution', p)
// 金泰原料运单下的货物删除
export const delGoodForVDistribution = p => post(name + '/vGoods/delGoodForVDistribution', p)
// 金泰添加码单
export const addVBillForJT = p => post(name + '/vBill/addVBillForJT', p)
// 金泰修改码单
export const updateVBillForJT = p => post(name + '/vBill/updateVBillForJT', p)
// 金泰关联货物列表
export const findGoodForVBill = p => post(name + '/vGoods/findGoodForVBill', p)
// 金泰关联货物
export const addVBillGoods = p => post(name + '/vBill/addVBillGoods', p)
// 金泰取消关联货物
export const delVBillGoods = p => post(name + '/vBill/delVBillGoods', p)
// 金泰码单完成
export const completeVBill = p => post(name + '/vBill/completeVBill', p)
// 全部货源添加结算客户
export const updateSettlementCustomer = p => post(name + '/vGoods/updateSettlementCustomer', p)
// 判断配货单挂靠声明是否合规（贾）
export const checkRel = p => post(driverNameT + '/cDriverVehicleRel/checkRel', p)
// 用于配货上报收款方查询车队长
export const findRelByvhIdAndDriId = p => post(driverNameT + '/cDriverVehicleRel/findRelByvhIdAndDriId', p)
// 货物核查
export const checkGoods = p => post(name + '/vGoods/checkGoods', p)
// =====找车相关接口===============
// 竞价货源（梁）
export const biddingCargoList = p => post(`/${orderName}/sDemandOffer/biddingCargoList`, p)
// 抢单货源（梁）
export const seckillCargoList = p => post(`/${orderName}/sDemandOffer/seckillCargoList`, p)
// 我得竞价（梁）
export const myBiddingCargoList = p => post(`/${orderName}/sDemandOffer/myBiddingCargoList`, p)
// 我得抢单（梁）
export const mySeckillCargoList = p => post(`/${orderName}/sDemandOffer/mySeckillCargoList`, p)
// 抢单（常）
export const grabDemand = p => post(`/${orderName}/sDemand/grabDemand`, p)
// 最新抢单价格（常）
export const countPrice = p => post(`/${orderName}/sDemand/countPrice`, p)
// 忽略（常）
export const ignoreDemand = p => post(`/${orderName}/sDemand/ignoreDemand`, p)
// 报价改价（梁）
export const reportPrice = p => post(`/${orderName}/sDemandOffer/reportPrice`, p)
// 查看结果（梁）
export const showBiddingResult = p => post(`/${orderName}/sDemandOffer/showBiddingResult`, p)
// 需求详情（常）
export const sDemandDetail = p => post(`/${orderName}/sDemand/detail`, p)
// 车队派车（常）
export const splitDemand = p => post(`/${orderName}/sDemand/splitDemand`, p)
// 指派货物列表（常）
export const appointCargoList = p => post(`/${orderName}/sDemandOffer/appointCargoList `, p)
// 我的指派列表（常）
export const myAppointCargoList = p => post(`/${orderName}/sDemandOffer/myAppointCargoList`, p)
// 指派接收（常）
export const acceptDemand = p => post(`/${orderName}/sDemand/acceptDemand`, p)
// 指派拒绝（常）
export const refuseDemand = p => post(`/${orderName}/sDemand/refuseDemand`, p)
// 货源中心未处理件数（平）
export const demandListCount = p => post(`/${orderName}/sDemandOffer/demandListCount`, p)
